import React from 'react'
import PlayKaroSlots from '../../components/PlayKaroLiveCasino/PlayKaroSlots'

const PlayKaroSlotsPage = () => <PlayKaroSlots />

export default PlayKaroSlotsPage
